<template>
  <v-container style="padding-top: 20px" class="mb-10">
    <div class="title-wrapper mb-8 ml-4">
      <h3 class="page-title section-title" align="left">{{ lg_vote_report.title }}</h3>
      <!-- <h4 class="page-sub-title">{{ lg_vote_report.search_conditions }}</h4> -->
    </div>
    <!-- vertical-top-row px-5   use for top position in table is class after elevation-1-->
     <v-row class="my-6">
    <v-col cols="12" sm="7" md="5">
      <!-- append-icon="search" -->
            <v-text-field
              v-model="search"
              :label="lg_vote_report.search"
              single-line
              hide-details
              outlined
              style="border-radius:10px;"
            ></v-text-field>
          </v-col>
          </v-row>
    <v-data-table
      style="border-radius:10px;overflow: hidden;"
      :headers="lg_vote_report.headers"
      :items="reports"
      class="elevation-1 "
      :loading="loading"
      :items-per-page="itemsPerPage"
      :search="search"
    >
      <!-- <template v-slot:top>
        <v-row class="px-4">
          <v-menu
            v-model="dateMenuVisible"
            :close-on-content-click="false"
            max-width="290"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
              class="mx-4"
                :value="renderDateSearch"
                clearable
                :label="lg_vote_report.search_date"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="dateSearch = null"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateSearch"
              @change="dateMenuVisible = false"
            ></v-date-picker>
          </v-menu>

          <v-text-field
            v-model="topicSearch"
            class="mx-4"
            :label="lg_vote_report.search_topic"
            :clearable="true"
          ></v-text-field>

          <v-text-field
            v-model="createdBySearch"
            class="mx-4"
            :label="lg_vote_report.search_user"
            :clearable="true"
          ></v-text-field>
         
         
        </v-row>
      </template> -->

      <template v-slot:item.created_at="{ item }">
        {{ new Date(item.created_at).toLocaleDateString('en-GB',{
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    })}}
      </template>

      <template v-slot:item.options="{ item }">
        <p
          v-for="(o, i) in JSON.parse(item.options)"
          :key="`${o.id}-${i}`"
          style="margin: 0"
        >
          <span class="mr-2">{{ i + 1 }}.</span>
          <span class="mr-2">{{ o.text }}</span>
        </p>
      </template>

      <template v-slot:item.voted="{ item }">
        {{ JSON.parse(item.voted).length }}
      </template>

      <template v-slot:item.action="{ item }">
        <!-- <v-btn  color="#3E73BB" dark class="rounded-pill" @click="createPdf(item)">View</v-btn> -->
  <v-btn  color="#3E73BB" dark class="slide-btn" @click="exportToPDFBypdfMake(item)">View</v-btn>
      </template>

    </v-data-table>
    <template>
      <VotePdfDialog
        v-if="setdatavote"
        :datavote="setdatavote"
        :visible="pdfDialog"
        :key="setdatavoteshow"
        @on-cancel="pdfDialog = false"
      />
    </template>

    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import api from "@/services/api";
import { format, parseISO } from "date-fns";
import VotePdfDialog from "@/components/core/VotePdfDialog";
import { server } from "../services/constants";
import LoadingDialog from "@/components/cards/LoadingDialog.vue";
import { feature } from "../services/constants";
import { lg_vote_report } from "./language/lg_vote_report";
import { lg_vote_pdf_dialog } from "../views/language/lg_vote_pdf_dialog";
import pdfvotereport from "@/utils/pdfvotereport";

export default {
  data: () => ({
    search:"",
    itemsPerPage: 5,
    setdatavoteshow: 0,
    votes: [],
    setdatavote: "",
    createdBySearch: null,
    topicSearch: null,
    dateMenuVisible: false,
    dateSearch: null,
    loading: false,
    pdfDialog: false,
    pdfBytes: null,
    userRole: null,
    company_id: null,
  }),
  components: {
    VotePdfDialog,
    LoadingDialog,
  },
  computed: {
    renderDateSearch() {
      return this.dateSearch
        ? format(parseISO(this.dateSearch), "dd/MM/yyyy")
        : "";
    },
    reports() {
      const { votes, createdBySearch, topicSearch, dateSearch } = this;
      const reports = votes.filter((v) => {
        const {  meet_topic, created_at,question } = v;
        const validCreatedBy =
          createdBySearch?.length > 0
            ? question?.toLowerCase()?.includes(createdBySearch?.toLowerCase())
            : true;
        const validTopic =
          topicSearch?.length > 0
            ? meet_topic?.toLowerCase()?.includes(topicSearch?.toLowerCase())
            : true;

            const validDate = dateSearch
          ?  new Date(created_at).toLocaleDateString('en-CA') &&
          new Date(created_at).toLocaleDateString('en-CA') ===
          dateSearch
          : true;
        return validCreatedBy && validTopic && validDate;
      });

      return reports;
    },
  },
  methods: {
      async exportToPDFBypdfMake(item) {
        let setdata;
        this.$store.state.loadMenu = true;
      try {
         if(item.session_id && item.session_id !== ""){
        const res = await api.getgetsessionId(item.session_id);
      setdata = {...item,total_participants:res.data.participants.length?res.data.participants.length:0,participants:res.data.participants};
      }else{
      setdata = item;
      }

        // เรียกใช้ generator
        await pdfvotereport.exportToPDF(setdata,this.lg_vote_pdf_dialog);
       this.$store.state.loadMenu = false;
      } catch (error) {
        this.$store.state.loadMenu = false;
        console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },
    async createPdf(item) {
      // console.log("createPdf:", JSON.stringify(item));
      // console.log(item.session_id);
      if(item.session_id && item.session_id !== ""){
        const res = await api.getgetsessionId(item.session_id);
        this.setdatavoteshow++;
      this.setdatavote = {...item,total_participants:res.data.total_participants?res.data.total_participants:0};
      this.pdfDialog = true;
      }else{
    //  this.$refs.listroom.loadListRoomMeetingData();
     this.setdatavoteshow++;
      // item.options = JSON.parse(item.options);
      this.setdatavote = item;
      this.pdfDialog = true;
      }
   
 
      // try {
      //   const body = item;
      //   if (item.room && item.room.meet_topic) {
      //     body.roomName = item.room.meet_topic;
      //   }
      //   const response = await api.getVoteReport(body);
      //   console.log(response)
      //   if (response && response.data && response.data.pdfBytes) {
      //     this.pdfBytes = Uint8Array.from(
      //       Object.values(response.data.pdfBytes)
      //     );
      //     this.pdfDialog = true;
      //   }
      // } catch (e) {
      //   console.log(e.message);
      // }
    },
    async fetchVotes() {
      try {
        this.loading = true;
        let result;
        let setdata = [];
        let role = localStorage.getItem(server.ROLE);
        let userId = localStorage.getItem(server.USER_ID)?localStorage.getItem(server.USER_ID):0;
        if (role == "Admin") {
          result= await api.getAllPollVote();
          this.votes = result.data;
        }else{
          result= await api.getAllPollVoteByOwnerId(userId);
          if(result.data.length > 0){
            result.data.filter((x,i)=>{
              setdata.push(x.tbl_poll_vote);
              if(i == result.data.length-1){
                this.votes = setdata;
              }
            });
          }
         
        }

      if(result.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }
        // if(result.data){
        //   result.data.
        // }
       
        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.$swal.fire("Error", error.message, "error");
      }
    },
  },
  beforeCreate() {
        if (api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$store.state.loadFooter = false;
      this.$router.push("/login-account");
    }
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_vote_report = lg_vote_report.vote_report_th)
      : (this.lg_vote_report = lg_vote_report.vote_report_en);

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_vote_pdf_dialog = lg_vote_pdf_dialog.vote_pdf_dialog_th)
      : (this.lg_vote_pdf_dialog = lg_vote_pdf_dialog.vote_pdf_dialog_en);

  },
  async created() {
    this.$store.state.loadFooter = false;
    try {
      const role = localStorage.getItem(server.ROLE);
      this.company_id = localStorage.getItem("company_id");
      this.userRole = role;
    } catch (e) {
      console.log(e.message);
    }
    if (api.isLoggedIn()) {
      this.fetchVotes();
    }
  },
};
</script>

<style>
.vertical-top-row > .v-data-table__wrapper > table > tbody > tr {
  vertical-align: text-top;
}

.title-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.page-sub-title {
  font-weight: 400;
}
/*
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
    display: block;
}
.apexcharts-xaxis-title{
  font-size:12px;
}
*/
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 85px;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    border-top: thin solid rgba(0, 0, 0, 0.12);
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #F8F9FA;
    color: black;
    font-size: 14px;
}

</style>
